import React, { createContext, useContext, useState, ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
// @ts-ignore
import UserProfileModal from '../components/UserProfileModal';

interface UserProfileContextType {
    openProfile: (userId: string) => void;
}

const UserProfileContext = createContext<UserProfileContextType | undefined>(undefined);

export const UserProfileProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [profileUserId, setProfileUserId] = useState<string | null>(null);
    const navigate = useNavigate();
    const location = useLocation();

    const openProfile = React.useCallback((userId: string) => {
        console.log('[UserProfileContext] openProfile called for:', userId);
        // Check authentication
        const token = localStorage.getItem('rideclub_token');
        if (!token) {
            console.warn('[UserProfileContext] No token found, redirecting to register');
            const returnUrl = location.pathname + location.search;
            navigate('/register', { state: { returnUrl } });
            return;
        }
        setProfileUserId(userId);
    }, [location.pathname, location.search, navigate]);

    const closeProfile = React.useCallback(() => {
        console.log('[UserProfileContext] closeProfile called');
        setProfileUserId(null);
    }, []);

    const contextValue = React.useMemo(() => ({ openProfile }), [openProfile]);

    return (
        <UserProfileContext.Provider value={contextValue}>
            {children}
            {/* We render the modal here at the root level */}
            <UserProfileModal
                isOpen={!!profileUserId}
                onClose={closeProfile}
                userId={profileUserId || ''}
            />
        </UserProfileContext.Provider>
    );
};

export const useUserProfile = () => {
    const context = useContext(UserProfileContext);
    if (!context) {
        throw new Error('useUserProfile must be used within a UserProfileProvider');
    }
    return context;
};
